import { useState, useCallback, useEffect } from 'react';
import { EventData, EVENTS, STATUS, Step } from 'react-joyride';

const TOUR_KEY = 'solimat-centers-tour-v1';

const BASE_STEPS: Step[] = [
  {
    target: '.centros-filter',
    title: 'Buscador de centros',
    content: 'Desde aquí puedes seleccionar tu provincia para ver los centros Solimat disponibles en tu zona.',
    placement: 'bottom',
    skipBeacon: true,
  },
  {
    target: '.centros-filter__field',
    title: 'Seleccionar provincia',
    content: 'Despliega el selector y elige tu provincia. Los centros y el mapa se actualizarán automáticamente.',
    placement: 'bottom',
    skipBeacon: true,
  },
];

const RESULTS_STEPS: Step[] = [
  {
    target: '.centros-group',
    title: 'Centros disponibles',
    content: 'Aquí se muestran todos los centros Solimat de la provincia seleccionada. El número junto al nombre indica cuántos centros hay.',
    placement: 'top',
    skipBeacon: true,
  },
  {
    target: '.centers-map',
    title: 'Mapa de centros',
    content: 'El mapa muestra la ubicación geográfica de todos los centros. Haz clic en cualquier marcador para ver más detalles.',
    placement: 'top',
    skipBeacon: true,
  },
  {
    target: '.centros-search',
    title: 'Buscar centro',
    content: 'Filtra los centros por nombre o dirección para encontrar rápidamente el que necesitas.',
    placement: 'bottom',
    skipBeacon: true,
  },
  {
    target: '.centers',
    title: 'Listado de centros',
    content: 'Cada tarjeta muestra el nombre del centro, su dirección y teléfono. Haz clic en una tarjeta para ver el detalle completo del centro.',
    placement: 'top',
    skipBeacon: true,
  },
];

export const useCentersTour = (hasCenters: boolean) => {
  const [run, setRun] = useState(false);
  const [tourKey, setTourKey] = useState(0);

  const steps = hasCenters ? [...BASE_STEPS, ...RESULTS_STEPS] : BASE_STEPS;

  const handleCallback = useCallback((data: EventData) => {
    const { type, status, index } = data as any;
    const finished = status === STATUS.FINISHED || status === STATUS.SKIPPED;

    if (finished || (type as string) === EVENTS.TOUR_END) {
      setRun(false);
      localStorage.setItem(TOUR_KEY, 'true');
      window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: false } }));
    }

    if ((type as string) === EVENTS.STEP_AFTER && index === 0) {
      window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: false } }));
    }
  }, []);

  const startTour = useCallback(() => {
    setRun(current => {
      if (current) return false;
      setTourKey(k => k + 1);
      return true;
    });
  }, []);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: run } }));
  }, [run]);

  return { run, tourKey, steps, handleCallback, startTour };
};
